import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "partner-metrics-chart" }
const _hoisted_2 = { class: "chart-legend" }
const _hoisted_3 = { class: "registrations" }
const _hoisted_4 = { class: "first-deposits" }
const _hoisted_5 = { class: "chart-periods" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "single-day-metrics"
}
const _hoisted_8 = {
  key: 1,
  viewBox: "0 0 560 160",
  role: "img",
  "aria-label": "График регистраций и первых депозитов"
}
const _hoisted_9 = ["y1", "y2"]
const _hoisted_10 = ["points"]
const _hoisted_11 = ["points"]
const _hoisted_12 = ["cx", "cy"]
const _hoisted_13 = ["cx", "cy"]
const _hoisted_14 = {
  x: "24",
  y: "154"
}
const _hoisted_15 = {
  x: "536",
  y: "154",
  "text-anchor": "end"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Динамика", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("Регистрации ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString($setup.total('registrations')), 1 /* TEXT */)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _cache[1] || (_cache[1] = _createTextVNode("FTD ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString($setup.total('first_deposits')), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.periods, ([value,text]) => {
          return _createElementVNode("button", {
            key: value,
            class: _normalizeClass({active:$setup.period===value}),
            onClick: $event => ($setup.period=value)
          }, _toDisplayString(text), 11 /* TEXT, CLASS, PROPS */, _hoisted_6)
        }), 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    ($setup.period===1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("small", null, "Регистрации", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString($setup.points[0]?.registrations || 0), 1 /* TEXT */)
          ]),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("small", null, "FTD", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString($setup.points[0]?.first_deposits || 0), 1 /* TEXT */)
          ])
        ]))
      : (_openBlock(), _createElementBlock("svg", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([30,82,134], (grid) => {
            return _createElementVNode("line", {
              key: grid,
              x1: "24",
              x2: "536",
              y1: grid,
              y2: grid,
              class: "chart-grid"
            }, null, 8 /* PROPS */, _hoisted_9)
          }), 64 /* STABLE_FRAGMENT */)),
          _createElementVNode("polyline", {
            points: $setup.line('registrations'),
            class: "chart-line registrations"
          }, null, 8 /* PROPS */, _hoisted_10),
          _createElementVNode("polyline", {
            points: $setup.line('first_deposits'),
            class: "chart-line first-deposits"
          }, null, 8 /* PROPS */, _hoisted_11),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.points, (point, index) => {
            return (_openBlock(), _createElementBlock("circle", {
              key: `r-${point.date}`,
              cx: $setup.x(index),
              cy: $setup.y(point.registrations),
              r: "3",
              class: "chart-dot registrations"
            }, [
              _createElementVNode("title", null, _toDisplayString($setup.label(point.date)) + " · Регистрации: " + _toDisplayString(point.registrations), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_12))
          }), 128 /* KEYED_FRAGMENT */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.points, (point, index) => {
            return (_openBlock(), _createElementBlock("circle", {
              key: `f-${point.date}`,
              cx: $setup.x(index),
              cy: $setup.y(point.first_deposits),
              r: "3",
              class: "chart-dot first-deposits"
            }, [
              _createElementVNode("title", null, _toDisplayString($setup.label(point.date)) + " · FTD: " + _toDisplayString(point.first_deposits), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_13))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("text", _hoisted_14, _toDisplayString($setup.label($setup.points[0]?.date)), 1 /* TEXT */),
          _createElementVNode("text", _hoisted_15, _toDisplayString($setup.label($setup.points[$setup.points.length-1]?.date)), 1 /* TEXT */)
        ]))
  ]))
}